export { default } from './AsyncComponent';



// WEBPACK FOOTER //
// ./src/components/common/AsyncComponent/index.js